import React, { useState, useEffect } from "react";
import App from "./App"; // Your existing dashboard
import { AdminLogin } from "./AdminLogin";

export default function RootApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // ✅ Clear login state on every page load
  useEffect(() => {
    localStorage.removeItem("admin-auth"); // force logout on refresh
    setIsLoggedIn(false);
  }, []);

  const handleLoginSuccess = () => setIsLoggedIn(true);

  // If not logged in, show login page
  if (!isLoggedIn) return <AdminLogin onLoginSuccess={handleLoginSuccess} />;

  // If logged in, show dashboard
  return <App />;
}




///// code for no reload or refresh /////
/*import React, { useState, useEffect } from "react";
import App from "./App"; // Your existing dashboard
import { AdminLogin } from "./AdminLogin";

export default function RootApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const auth = localStorage.getItem("admin-auth") === "true";
    setIsLoggedIn(auth);
  }, []);

  const handleLoginSuccess = () => setIsLoggedIn(true);

  if (!isLoggedIn) return <AdminLogin onLoginSuccess={handleLoginSuccess} />;

  return <App />;
}*/
